import React from "react";
import { PrismicPreviewProvider } from 'gatsby-plugin-prismic-previews';
import MuiRootWrapper from "./mui-root-wrapper"
import browserHydrateFunction from './browser-hydrate-function';

// export const wrapRootElement = MuiRootWrapper
export const wrapRootElement = ({ element }) => {
  console.log("wrapRootElement");
  
  return (
    <PrismicPreviewProvider
      repositoryConfigs={[
        {
          repositoryName: 'biiit',
          accessToken: process.env.ACCESS_TOKEN,
          linkResolver: require('./src/utils/linkResolver.js'),
        },
      ]}
    >
      {MuiRootWrapper({ element })}
    </PrismicPreviewProvider>
  );
};

const scriptForGTM = `window.dataLayer = window.dataLayer || []; window.dataLayer.push({ "platform": "gatsby" }); (function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl + ''; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer', 'GTM-K962HJT5');`;

export const shouldUpdateScroll = ({ routerProps }) => {
  if (routerProps.location.hash) {
    return false; // Не сохранять скролл, если есть хеш в URL
  }
  return [0, 0];
};

export const onInitialClientRender = () => {
  document.getElementsByClassName("prelauder")[0].style.display = "none"
  setTimeout(() => {
    if (process.env.NODE_ENV === 'production') {
      const gtmScript = document.createElement('script');
      gtmScript.defer = true;
      gtmScript.textContent = scriptForGTM;

      document.body.appendChild(gtmScript);
    }
  }, 4000);
}

export const onRouteUpdate = ({ location }) => {
  const hash = location.hash;

  if (!hash) {
    return;
  }

  const anchor = document.getElementById(hash.replace('#', ''));

  if (!anchor) {
    return;
  }

  anchor.scrollIntoView({ behavior: 'smooth' });
};

// export const onRouteUpdate = () => {
//   // const preloader = document.getElementsByClassName("prelauder");

//   // setTimeout(() => {
//   //   // preloader[0].style.display = "none";
//   // }, 100);
// };

// export const onClientEntry = () => {
//   // console.log('onClientEntry')
//   // document.getElementsByClassName("prelauder")[0].style.display = "flex"
// }


export const replaceHydrateFunction = browserHydrateFunction;
